var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('app-header'),_c('transition',{attrs:{"name":"fade","appear":""},on:{"after-leave":_vm.afterLeave,"after-appear":_vm.afterLeave}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }